<template>
  <div>
    <dashboard-page-title @addEvent="$router.push({name: 'addTax'})">الضرايب</dashboard-page-title>

    <main-table
      :baseURL="VUE_APP_MARKETPLACE_LINK"
      :fields="fields"
      list_url="admin/taxes"
      :reloadData="reloadData"
    ></main-table>

    <!-- Edit Tax Modal -->
    <b-modal
      id="editTaxModal"
      size="lg"
      title="تعديل الضريبة"
      style="direction: rtl"
      centered
      hide-footer
      @hidden="resetEditForm"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onEditSubmit)">
          <b-row>
            <b-col md="6" class="mb-3">
              <input-form placeholder="أدخل الاسم" label="الإسم" v-model="editTax.title" :validate="'required'" name="name"></input-form>
            </b-col>
            <b-col md="6" class="mb-3">
              <input-form placeholder="ادخل الرقم البريدى" label="الرقم البريدى" v-model="editTax.post_code" :validate="'required|regex:^\\d{5}$'" name="post code"></input-form>
            </b-col>
            <b-col md="6" class="mb-3">
              <input-form placeholder="النسبة" label="النسبة" v-model="editTax.percentage" :validate="'required'" name="percentage"></input-form>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-form-group label="اختر المدينة" label-for="edit-tax-city">
                <validation-provider name="city" rules="required" v-slot="{ errors }">
                  <b-form-select
                    id="edit-tax-city"
                    v-model="editTax.city"
                    :options="cityOptions"
                    value-field="value"
                    text-field="text"
                    class="form-control"
                    dir="rtl"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-end">
              <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('editTaxModal')">إلغاء</b-button>
              <b-button variant="primary" type="submit" v-if="!loadingSubmit">حفظ التعديلات</b-button>
              <b-button v-else variant="primary" class="text-white" disabled>
                <spinner-loading text="loading"></spinner-loading>
              </b-button>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_MARKETPLACE_LINK } from '@/config/constant'
import merchants from '@/modules/marketPlace/services/marketPlace'
import citiesAndCountriesMixin from '@/mixins/countriesAndCities'

export default {
  components: {},
  mixins: [citiesAndCountriesMixin],
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_MARKETPLACE_LINK,
      reloadData: false,
      loadingSubmit: false,
      editingTaxId: null,
      editTax: {
        title: '',
        post_code: '',
        percentage: '',
        city: ''
      },
      fields: [
        { label: 'الاسم', key: 'title', class: 'text-right' },
        { label: 'الرقم البريدي', key: 'post_code', class: 'text-right' },
        { label: 'القيمة', key: 'percentage', class: 'text-right' },
        { label: 'الحالة', key: 'status', type: 'status', class: 'text-right' },
        { label: 'التاريخ', key: 'created_at', class: 'text-right' },
        {
          label: 'التحكم',
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'edit',
              icon: 'ri-ball-pen-fill',
              color: 'info',
              actionName: 'openEditTaxModal',
              actionParams: ['id']
            },
            {
              text: 'Delete',
              icon: 'ri-delete-bin-line',
              color: 'danger',
              url: 'admin/taxes',
              baseUrl: VUE_APP_MARKETPLACE_LINK,
              titleHeader: 'ضريبة',
              question: '؟هل متأكد أنك تريد مسح هذه الضريبة',
              textContent: 'title',
              textDeleteButton: 'بالتأكيد, مسح',
              textCancelButton: 'إلغاء',
              showAlert: true
            }
          ]
        }
      ]
    }
  },
  computed: {
    cityOptions () {
      const cities = (this.allCities || []).map(city => ({ value: city.id, text: city.name }))
      return [{ value: '', text: 'اختر المدينة' }, ...cities]
    }
  },
  methods: {
    openEditTaxModal (data) {
      this.editingTaxId = data.id
      merchants.getTaxID(data.id).then(res => {
        const tax = res.data
        this.editTax = {
          title: tax.title || '',
          post_code: tax.post_code || '',
          percentage: tax.percentage || '',
          city: tax.city_id || tax.city?.id || tax.city || ''
        }
        this.$bvModal.show('editTaxModal')
      })
    },
    onEditSubmit () {
      this.loadingSubmit = true
      merchants.editTax(this.editingTaxId, this.editTax).then(() => {
        core.showSnackbar('success', 'تم تعديل الضريبة بنجاح')
        this.$bvModal.hide('editTaxModal')
        this.reloadData = true
        this.$nextTick(() => { this.reloadData = false })
      }).finally(() => {
        this.loadingSubmit = false
      })
    },
    resetEditForm () {
      this.editingTaxId = null
      this.editTax = {
        title: '',
        post_code: '',
        percentage: '',
        city: ''
      }
    }
  },
  created () {
    this.$root.$on('openEditTaxModal', this.openEditTaxModal)
  },
  beforeDestroy () {
    this.$root.$off('openEditTaxModal', this.openEditTaxModal)
  }
}
</script>
